<div class="layout">
  <app-sidebar />
  <div class="main-area">
    <app-navbar />
    <main class="content">
      <router-outlet />
    </main>
    <app-footer />
  </div>
</div>
